<template>
  <div class="permission-management-page">
    <permission-management />
  </div>
</template>

<script>
import PermissionManagement from '@/components/PermissionManagement.vue'

export default {
  name: 'PermissionManagementPage',
  components: {
    PermissionManagement
  }
}
</script>

<style scoped>
.permission-management-page {
  min-height: 100vh;
  padding: 16px;
  background-color: #f7f8fa;
}

@media (prefers-color-scheme: dark) {
  .permission-management-page {
    background-color: #1a1a1a;
  }
}
</style>
